define('models/Base',['core/can'], function(can) {
	
	var Base = can.Model.extend({
		
		id: 'EntityId',
		
		exportData: function(params, success, error) {
			App.loading();
			return can.ajax({
				type: 'POST',
				url: '/SingleUseTicket'
			})
			.then(function(data) {
				var url = '/' + params.Type + params.Url;
				var paramsStr = '?ticket=' + data.Ticket;

				delete params.Type;
				delete params.Url;

				paramsStr += '&' + $.param(params);

				window.location = config.api_url + url + paramsStr;
			})
			.then(success, error)
			.always(function() {
				App.loading(false);
			});
		}
		
	},{
		_id: can.compute(function() {
			return this.attr(this.constructor.id);
		}),
		

		// TODO if canjs doesn't update model automatically
		/*save: function(success, error) {
			return can.Model.prototype.save.call(this).then(function() {})
		},*/

		
		toUpperCase: function(attrs) {
			for (var i=0; i<attrs.length; i++) {
				var value = this.attr(attrs[i]);
				if (typeof value === 'string')
					this.attr(attrs[i], value.toUpperCase());
			}
			return this;
		}
	});
	
	Base.List.prototype.findById = function(id) {
		return this.filter(function(model) {
			return id === model.attr('_id');
		}).attr(0);
	};

	Base.List.prototype.findByProp = function(value, prop) {
		return this.filter(function(model) {
			return value === model.attr(prop);
		}).attr(0);
	};
	
	Base.List.prototype.deleteById = function(id) {	
		for (var i=0; i<this.attr('length'); i++) {
			if (this.attr(i).attr('_id') === id) {
				this.splice(i, 1);
				return;
			}
		}
	};
	
	return Base;
	
});
